import { Homepage } from "./pages/Homepage";

function App() {
  return (
    <div className="App w-full h-full no-scrollbar">
      <Homepage />
    </div>
  );
}

export default App;
